import { Component, Input } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { take } from 'rxjs';

@Component({
  selector: 'app-other-details',
  templateUrl: './other-details.component.html',
  styleUrls: ['./other-details.component.scss'],
})
export class OtherDetailsComponent {
  @Input() userUID: string | undefined;
  miscelleneous: any;
  personal = '../../../../assets/images/miscellaneous.png';
  constructor(private firestore: AngularFirestore) {}

  ngOnInit(): void {
    this.getPersonalInfo();
  }

  getPersonalInfo() {
    this.firestore
      .collection('miscelleneous')
      .doc(this.userUID)
      .get()
      .pipe(take(1))
      .subscribe((data: any) => {
        let obj = data.data();
        console.log(obj);
        // obj.firstName = obj.firstName + ' ' + obj.lastName;
        this.miscelleneous = obj;
      });
  }
}
